import {
  Alert,
  AlertTitle,
  Box,
  Button,
  IconButton,
  Paper,
  Typography,
  CircularProgress,
} from "@mui/material";
import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useGetEsitoCarrelloQuery } from "../../api/minework";
import useQueryParams from "../../hooks/useQueryParams";
import { PictureAsPdf } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

const TransactionResult = () => {
  const { lang, codice } = useParams();
  const query = useQueryParams();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const { data, isLoading } = useGetEsitoCarrelloQuery({
    id: query.get("cartId"),
  });

  if (isLoading) {
    return (
      <Paper sx={{ mt: 2, p: 4, textAlign: "center" }}>
        <CircularProgress />
      </Paper>
    );
  }

  if (data !== undefined) {
    return (
      <Paper sx={{ mt: 2, p: 2 }}>
        {data.esito && (
          <>
            <Alert severity="success" variant="filled">
              <AlertTitle>{t("transaction_result.completed_title")}</AlertTitle>
              {t("transaction_result.completed_desc")}
            </Alert>
            <Box sx={{ mt: 1 }} textAlign="center">
              <Typography textAlign="center">
                {t("transaction_result.download_voucher")}
              </Typography>
              <IconButton
                size="large"
                color="error"
                onClick={() => {
                  window.location.href = `https://minework.blob.core.windows.net/ricevute/${data.codice}.pdf`;
                }}
              >
                <PictureAsPdf sx={{ width: "200px", height: "200px" }} />
              </IconButton>
            </Box>
          </>
        )}
        {!data.esito && (
          <Alert severity="info" variant="filled">
            <AlertTitle>{t("transaction_result.pending_title")}</AlertTitle>
            {t("transaction_result.pending_desc")}
          </Alert>
        )}
        <Box sx={{ mt: 4 }} textAlign="center">
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              navigate(`/${lang}/${codice}`);
            }}
          >
            {t("transaction_result.return_button")}
          </Button>
        </Box>
      </Paper>
    );
  } else {
    return (
      <Paper sx={{ mt: 2, p: 2 }}>
        <Alert severity="error" variant="filled">
          {t("transaction_result.cart_not_found")}
        </Alert>
      </Paper>
    );
  }
};

export default TransactionResult;
